import { render, staticRenderFns } from "./clientProfileManageUsers.vue?vue&type=template&id=54f1a6b6&scoped=true"
import script from "./clientProfileManageUsers.vue?vue&type=script&lang=js"
export * from "./clientProfileManageUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f1a6b6",
  null
  
)

export default component.exports